const DynaCore_Item =
    {
        /**
         * Inicializace jednotlivych objektu
         */
        init: function () {
            DynaCore_Item.buttonInit();
            DynaCore_Item.fileInit();
            DynaCore_Item.elementsChangeInit();
            DynaCore_Item.gridInit();
            DynaCore_Item.miniformInit();
            DynaCore_Item.refreshInit();
            DynaCore_Item.tooltipInit();
        },

        /**
         * Inicializace objektu typu Button
         */
        buttonInit: function () {
            $('body')
                // Zrusime puvodni udalosti
                .off('click', '.button-miniform')

                // Zaregistrujeme nove udalosti
                .on('click', '.button-miniform', function (e) {
                    e.preventDefault();
                    DynaCore_Item.buttonMiniform(this);
                    return false;
                });
        },

        /**
         * Zobrazeni miniformulare objektu typu Button
         *
         * @param element
         */
        buttonMiniform: function (element) {
            let heading = $(element).data('heading');
            let miniformId = $(element).data('miniform-id');
            let partIndex = $(element).data('part-index');
            let partId = $(element).data('part-id');

            let url = window.location.href;
            url = url.replace('/item/add', '/item/modal-button');
            url = url.replace('/item/detail', '/item/modal-button');
            url = url.replace('/item/duplicate', '/item/modal-button');
            url = url.replace('/item/edit', '/item/modal-button');
            url = url.replace('/my-account', '/my-account/modal-button');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&paIn=' + partIndex + '&paId=' + partId + '&miId=' + miniformId;

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                success: function (data) {
                    $.each(data.messages, function (i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                    });

                    if (true === data.status) {
                        let formModified = DynaCore_Item.miniformItemSectionValuesLoad(data.html);

                        Lemo_Modal.setId('modal-container-button-miniform');
                        Lemo_Modal.setTitle(heading);
                        Lemo_Modal.setContent(formModified);
                        Lemo_Modal.addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function () {
                            $.ajax({
                                type: 'post',
                                url: url,
                                data: $('#modal-container-button-miniform').find(':input').serialize(),
                                dataType: "json",
                                success: function (r) {
                                    $.each(r.messages, function (i, message) {
                                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                                    });

                                    if (true === r.status) {
                                        // Do formulare polozky doplnime data z miniformulare
                                        DynaCore_Item.miniformItemSectionValuesPopulate('modal');

                                        // pre close trigger
                                        $(document).trigger({
                                            type: 'modal.button.miniform.close.pre',
                                            message: 'Button miniform close pre trigger fired.',
                                            time: new Date()
                                        }, {
                                            miniformId: miniformId
                                        });

                                        Lemo_Modal.close();

                                        // post close trigger
                                        $(document).trigger({
                                            type: 'modal.button.miniform.close.post',
                                            message: 'Button miniform close post trigger fired.',
                                            time: new Date()
                                        }, {
                                            miniformId: miniformId
                                        });

                                    } else {
                                        $('#dialogBody').html(r.html);

                                        // miniform error trigger
                                        $(document).trigger({
                                            type: 'modal.button.miniform.error',
                                            message: 'Button miniform error trigger fired.',
                                            time: new Date()
                                        }, {
                                            miniformId: miniformId
                                        });
                                    }
                                }
                            });
                        });
                        Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                            Lemo_Modal.close();
                        });
                        Lemo_Modal.build(function () {
                            // post build trigger
                            $(document).trigger({
                                type: 'modal.button.miniform.build',
                                message: 'Button miniform trigger fired.',
                                time: new Date()
                            }, {
                                miniformId: miniformId
                            });
                        });
                    }
                }
            });
        },

        elementsChangeInit: function () {
            $(document).find(":input").each(function(){
                $(this).on("change", function(){
                    $(document).trigger({
                        type: "dynabase.force.deactivation",
                        message: "Form element change trigger fired.",
                        time: new Date()
                    });
                });
            });
        },

        /**
         * Inicializace objektu typu Miniform
         */
        fileInit: function () {

            const elForm = $('.el-form');
            const elMiniform = $('.el-miniform');

            // Stazeni
            elForm.add(elMiniform)
                .off('click', '.file-download')
                .on('click', '.file-download', function (e) {
                    e.preventDefault();
                    DynaCore_Item.fileDownload(this);
                    return false;
                });

            // Prejmenovani
            elForm
                .off('click', '.file-rename')
                .on('click', '.file-rename', function (e) {
                    e.preventDefault();
                    DynaCore_Item.fileRename(this);
                    return false;
                });

            // Prejmenovani - Ulozeni
            elForm
                .off('click', '.file-rename-save')
                .on('click', '.file-rename-save', function (e) {
                    e.preventDefault();
                    DynaCore_Item.fileRenameSave(this);
                    return false;
                });

            // Prejmenovani - Zruseni
            elForm
                .off('click', '.file-rename-cancel')
                .on('click', '.file-rename-cancel', function (e) {
                    e.preventDefault();
                    DynaCore_Item.fileRenameCancel(this);
                    return false;
                });

            // Smazani
            elForm
                .off('click', '.file-delete')
                .on('click', '.file-delete', function (e) {
                    e.preventDefault();
                    DynaCore_Item.fileDelete(this);
                    return false;
                });
        },

        /**
         * Obsluzny JS pro smazani souboru
         *
         * @param elementButton
         */
        fileDelete: function (elementButton) {
            let elementParent = $(elementButton).data('element-parent');
            let fileField = $(elementButton).data('file-field');
            let fileType = $(elementButton).data('file-type');
            let urlAppend = '';

            // Data dle typu elementu
            if ('multiple' === fileType) {
                urlAppend += '&filInd=' + $(elementButton).data('file-index');
            }

            // Date dle nadrazeneho elementu
            if ('modal' === elementParent) {
                let elementModal = $(elementButton).parents('#modal-miniform').first();

                urlAppend += '&minId=' + $(elementModal).data('miniform-id');
                urlAppend += '&minIteInd=' + $(elementModal).data('item-index');
            }

            let url = window.location.href;
            url = url.replace('/item/add', '/item/file-delete');
            url = url.replace('/item/duplicate', '/item/file-delete');
            url = url.replace('/item/edit', '/item/file-delete');
            url = url.replace('/my-account', '/my-account/file-delete');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&elePar=' + elementParent + '&filFie=' + fileField + '&filTyp=' + fileType + urlAppend;

            Lemo_Modal
                .setId('modal-container-file-delete')
                .setTitle('Remove file')
                .setContent('<p class="text">' + translate('Do you really want to remove selected file?') + '</p>')
                .addButton('remove', '<i class="fas fa-fw fa-trash"></i> ' + translate('Remove'), 'btn btn-danger', function () {

                    Lemo_Modal.close();

                    $.ajax({
                        type: 'get',
                        url: url,
                        dataType: "json",
                        success: function (data) {
                            $.each(data.messages, function (i, message) {
                                Lemo_Alert.build(message.type, message.title, message.text, message.id);
                            });

                            if (true === data.status) {
                                let elementTable = $(elementButton).parents().find('.table-files');
                                $(elementButton).parents('tr').remove();

                                DynaCore_Item.fileReindex(elementTable);
                            }
                        },
                        error: function (jqXHR) {
                            DynaCore_Item.alertXhrError(jqXHR);
                        }
                    });
                })
                .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                    Lemo_Modal.close();
                });

            Lemo_Modal.build();
        },

        /**
         * Stazeni souboru polozky objektu typu Miniform
         *
         * @param elementButton
         */
        fileDownload: function (elementButton) {
            let elementParent = $(elementButton).data('element-parent');
            let fileField = $(elementButton).data('file-field');
            let fileType = $(elementButton).data('file-type');
            let urlAppend = '';

            // Data dle typu elementu
            if ('multiple' === fileType) {
                urlAppend += '&filInd=' + $(elementButton).data('file-index');
            }

            // Date dle nadrazeneho elementu
            let uuid = '';
            switch (elementParent) {
                case 'miniform':
                    let elementMiniform = $(elementButton).parents('.el-miniform');
                    let elementTr = $(elementButton).parents('tr');

                    urlAppend += '&minId=' + $(elementMiniform).data('miniform-id');
                    urlAppend += '&minIteInd=' + $(elementTr).data('item-index');
                    uuid += $(elementTr).data('item-uuid');
                    break;
                case 'modal':
                    let elementModal = $(elementButton).parents('#modal-miniform').first();

                    urlAppend += '&minId=' + $(elementModal).data('miniform-id');
                    urlAppend += '&minIteInd=' + $(elementModal).data('item-index');
                    break;
            }

            let url = window.location.href;
            url = url.replace('/item/add', '/item/file-download');
            url = url.replace('/item/duplicate', '/item/file-download');
            url = url.replace('/item/edit', '/item/file-download');
            url = url.replace('/item/detail', '/item/file-download');
            url = url.replace('/my-account', '/my-account/file-download');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&elePar=' + elementParent + '&filFie=' + fileField + '&filTyp=' + fileType + urlAppend;

            $.ajax({
                type: 'get',
                url: url + '&che=1',
                dataType: "json",
                global: false,
                success: function (data) {
                    $.each(data.messages, function (i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                    });

                    $(document).trigger({
                        type: 'miniform.file.download.success',
                        message: 'File download trigger fired.',
                        time: new Date()
                    }, {'uuid': uuid});

                    if (true === data.status) {
                        window.location = url;
                    }
                },
                error: function (jqXHR) {
                    DynaCore_Item.alertXhrError(jqXHR);
                }
            });
        },

        /**
         * Reindexace polozek v tabulce souboru
         *
         * @param elementTable
         */
        fileReindex: function (elementTable) {
            $(elementTable).find('tr').each(function (indexRow, row) {
                $(row).find('.file-delete').attr('data-file-index', indexRow);
            });
        },

        /**
         * Obsluzny JS pro smazani souboru
         *
         * @param elementButton
         */
        fileRename: function (elementButton) {
            const elementParent = $(elementButton).data('element-parent');
            const elementA = $(elementButton).parents('tr').find('a');
            let fileName = $(elementA).text();
            const fileField = $(elementButton).data('file-field');
            const fileType = $(elementButton).data('file-type');
            const fileIndex = $(elementButton).data('file-index');
            let fileExtension = '';

            fileExtension = fileName.match(/\.([a-zA-Z]+)$/);
            fileExtension = fileExtension[0];
            fileName = fileName.replace(fileExtension, '');

            const input = $('<input type="text" name="file-rename-name-' + fileIndex + '" class="form-control form-control-sm file-rename-name" value="' + fileName + '">');
            const buttonSave = $('<button class="btn btn-xs btn-primary file-rename-save" title="' + translate('Change') + '" data-element-parent="' + elementParent + '" data-file-field="' + fileField + '" data-file-type="' + fileType + '" data-file-index="' + fileIndex + '"><i class="fas fa-fw fa-check"></i></button>');
            const buttonCancel = $('<button class="btn btn-xs btn-secondary file-rename-cancel" title="' + translate('Close') + '" data-element-parent="' + elementParent + '" data-file-field="' + fileField + '" data-file-type="' + fileType + '" data-file-index="' + fileIndex + '"><i class="fas fa-fw fa-times"></i></button>');

            // Vlozime element Text
            $(elementA).parent().append(input);
            $(elementA).addClass('d-none');
            $(input).focus().select();

            // Vlozime elementy Button
            $(elementButton).parent().append(buttonSave);
            $(elementButton).parent().append('\n');
            $(elementButton).parent().append(buttonCancel);
            $(elementButton).parent().find('.file-rename, .file-download, .file-delete').addClass('d-none');

            DynaCore_Item.fileInit();
        },

        /**
         * Obsluzny JS pro smazani souboru
         *
         * @param elementButton
         */
        fileRenameSave: function (elementButton) {
            const elementParent = $(elementButton).data('element-parent');
            const elementA = $(elementButton).parents('tr').find('a');
            const fileField = $(elementButton).data('file-field');
            const fileName = $(elementA).parent().find('.file-rename-name').val();
            const fileType = $(elementButton).data('file-type');
            let urlAppend = '';

            // Data dle typu elementu
            if ('multiple' === fileType) {
                urlAppend += '&filInd=' + $(elementButton).data('file-index');
            }

            // Date dle nadrazeneho elementu
            switch (elementParent) {
                case 'miniform':
                    const elementMiniform = $(elementButton).parents('.el-miniform');
                    const elementTr = $(elementButton).parents('tr');

                    urlAppend += '&minId=' + $(elementMiniform).data('miniform-id');
                    urlAppend += '&minIteInd=' + $(elementTr).data('item-index');
                    break;
                case 'modal':
                    const elementModal = $(elementButton).parents('#modal-miniform').first();

                    urlAppend += '&minId=' + $(elementModal).data('miniform-id');
                    urlAppend += '&minIteInd=' + $(elementModal).data('item-index');
                    break;
            }

            let url = window.location.href;
            url = url.replace('/item/add', '/item/file-rename');
            url = url.replace('/item/duplicate', '/item/file-rename');
            url = url.replace('/item/edit', '/item/file-rename');
            url = url.replace('/item/detail', '/item/file-rename');
            url = url.replace('/my-account', '/my-account/file-rename');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&elePar=' + elementParent + '&filFie=' + fileField + '&filTyp=' + fileType + urlAppend;

            $.ajax({
                type: 'post',
                url: url,
                data: {name: fileName},
                dataType: "json",
                success: function (data) {
                    $.each(data.messages, function (i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                    });

                    if (true === data.status) {
                        let fileExtension = $(elementA).text().match(/\.([a-zA-Z]+)$/);

                        // Aktualizujeme nazev u odkazu
                        $(elementA).text(fileName + fileExtension[0]);

                        DynaCore_Item.fileRenameCancel(elementButton);
                    }
                },
                error: function (jqXHR) {
                    DynaCore_Item.alertXhrError(jqXHR);
                }
            });
        },

        /**
         * Obsluzny JS pro zruseni prejmenovani souboru
         *
         * @param elementButton
         */
        fileRenameCancel: function (elementButton) {
            const elementA = $(elementButton).parents('tr').find('a');

            // Odstranime element Text
            $(elementA).parent().find('input').remove();
            $(elementA).removeClass('d-none');

            // Odstranime elementy Button
            $(elementButton).parent().find('.file-rename, .file-download, .file-delete').removeClass('d-none');
            $(elementButton).parent().find('.file-rename-save, .file-rename-cancel').remove();
        },

        /**
         * Inicializace objektu typu Grid
         */
        gridInit: function () {
            $('body')
                // Zrusime puvodni udalosti
                .off('click', '.grid-item-add')
                .off('click', '.grid-item-delete')
                .off('click', '.grid-item-edit')

                // Zaregistrujeme nove udalosti
                .on('click', '.grid-item-add', function (e) {
                    e.preventDefault();
                    DynaCore_Item.gridItemAdd(this);
                    return false;
                })
                .on('click', '.grid-item-delete', function (e) {
                    e.preventDefault();
                    DynaCore_Item.gridItemDelete(this);
                    return false;
                })
                .on('click', '.grid-item-edit', function (e) {
                    e.preventDefault();
                    DynaCore_Item.gridItemEdit(this);
                    return false;
                });
        },

        /**
         * Pridani polozky objektu typu Grid
         *
         * @param element
         */
        gridItemAdd: function (element) {
            const heading = $(element).parents('.el-grid').data('heading-add');
            const partId = $(element).data('part-id');
            const sectionId = $('#idSection').val();

            let url = window.location.href;
            url = url.replace('/item/add', '/item/modal-grid');
            url = url.replace('/item/duplicate', '/item/modal-grid');
            url = url.replace('/item/edit', '/item/modal-grid');
            url = url.replace('/my-account', '/my-account/modal-grid');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&paId=' + partId + '&a=add';

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                success: function (data) {
                    $.each(data.messages, function (i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                    });

                    if (true === data.status) {
                        Lemo_Modal.setId('modal-container-grid-item-add');
                        Lemo_Modal.setTitle(heading);
                        Lemo_Modal.setContent(data.html);
                        Lemo_Modal.addButton('save', '<i class="fas fa-fw fa-check"></i> ' + translate('Add'), 'btn btn-primary', function () {
                            $.ajax({
                                type: 'post',
                                url: url,
                                data: $('#modal-container-grid-item-add').find(':input').serialize(),
                                dataType: "json",
                                success: function (data) {
                                    $.each(data.messages, function (i, message) {
                                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                                    });

                                    if (true === data.status) {
                                        $('#grid_section_i' + sectionId + '_i' + partId).trigger("reloadGrid");

                                        Lemo_Modal.close();
                                    } else {
                                        $('#dialogBody').html(data.html);

                                        const pathArray = window.location.pathname.split('/');
                                        let selector = '';
                                        if ($('#modal-itemTo').length > 0) {
                                            selector = '#modal-itemTo';
                                        } else {
                                            selector = '#modal-itemFrom';
                                        }

                                        Lemo_Autocomplete.build('#modal-container-grid-item-add', selector, '/core/item/autocomplete-values-grid', {
                                            _ch: $('#_ch').val(),
                                            gri: partId,
                                            ali: pathArray[2]
                                        });
                                    }
                                }
                            });
                        });
                        Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                            Lemo_Modal.close();
                        });
                        Lemo_Modal.build();

                        let pathArray = window.location.pathname.split('/');
                        let selector = '';
                        if ($('#modal-itemTo').length > 0) {
                            selector = '#modal-itemTo';
                        } else {
                            selector = '#modal-itemFrom';
                        }

                        Lemo_Autocomplete.build('#modal-container-grid-item-add', selector, '/core/item/autocomplete-values-grid', {
                            _ch: $('#_ch').val(),
                            gri: partId,
                            ali: pathArray[2]
                        });
                    }
                }
            });
        },

        /**
         * Upraveni polozky objektu typu Grid
         *
         * @param element
         */
        gridItemEdit: function (element) {
            const heading = $(element).parents('.el-grid').data('heading-edit');
            const itemIndex = $(element).data('item-index');
            const partId = $(element).data('part-id');
            const sectionId = $('#idSection').val();

            let url = window.location.href;
            url = url.replace('/item/add', '/item/modal-grid');
            url = url.replace('/item/duplicate', '/item/modal-grid');
            url = url.replace('/item/edit', '/item/modal-grid');
            url = url.replace('/my-account', '/my-account/modal-grid');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&paId=' + partId + '&itIn=' + itemIndex + '&a=edit';

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                success: function (data) {
                    $.each(data.messages, function (i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                    });

                    if (true === data.status) {
                        Lemo_Modal.setId('modal-container-grid-item-edit');
                        Lemo_Modal.setTitle(heading);
                        Lemo_Modal.setContent(data.html);
                        Lemo_Modal.addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function () {
                            $.ajax({
                                type: 'post',
                                url: url,
                                data: $('#modal-container-grid-item-edit').find(':input').serialize(),
                                dataType: "json",
                                success: function (data) {
                                    $.each(data.messages, function (i, message) {
                                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                                    });

                                    if (true === data.status) {
                                        $('#grid_section_i' + sectionId + '_i' + partId).trigger("reloadGrid");

                                        Lemo_Modal.close();
                                    } else {
                                        $('#dialogBody').html(data.html);

                                        const pathArray = window.location.pathname.split('/');
                                        let selector = '';
                                        if ($('#modal-itemTo').length > 0) {
                                            selector = '#modal-itemTo';
                                        } else {
                                            selector = '#modal-itemFrom';
                                        }

                                        Lemo_Autocomplete.build('#modal-container-grid-item-edit', selector, '/core/item/autocomplete-values-grid', {
                                            _ch: $('#_ch').val(),
                                            gri: partId,
                                            ali: pathArray[2]
                                        });
                                    }
                                }
                            });
                        });
                        Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                            Lemo_Modal.close();
                        });
                        Lemo_Modal.build();

                        let pathArray = window.location.pathname.split('/');
                        let selector = '';
                        if ($('#modal-itemTo').length > 0) {
                            selector = '#modal-itemTo';
                        } else {
                            selector = '#modal-itemFrom';
                        }

                        Lemo_Autocomplete.build('#modal-container-grid-item-edit', selector, '/core/item/autocomplete-values-grid', {
                            _ch: $('#_ch').val(),
                            gri: partId,
                            ali: pathArray[2]
                        });
                    }
                }
            });
        },

        /**
         * Smazani polozky objektu typu Grid
         *
         * @param element
         */
        gridItemDelete: function (element) {
            const heading = $(element).parents('.el-grid').data('heading-delete');
            const itemIndex = $(element).data('item-index');
            const partId = $(element).data('part-id');
            const sectionId = $('#idSection').val();

            let url = window.location.href;

            url = url.replace('/item/add', '/item/grid-item-delete');
            url = url.replace('/item/duplicate', '/item/grid-item-delete');
            url = url.replace('/item/edit', '/item/grid-item-delete');
            url = url.replace('/my-account', '/my-account/grid-item-delete');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&paId=' + partId + '&itIn=' + itemIndex;

            Lemo_Modal
                .setId('modal-container-grid-item-delete')
                .setTitle(heading)
                .setContent('<p class="text">' + translate('Do you really want to remove selected item?') + '</p>')
                .addButton('delete', '<i class="fas fa-fw fa-trash"></i> ' + translate('Remove'), 'btn btn-danger', function () {
                    $.ajax({
                        type: 'get',
                        url: url,
                        dataType: "json",
                        success: function () {
                            $('#grid_section_i' + sectionId + '_i' + partId).trigger("reloadGrid");
                        },
                        complete: function () {
                            Lemo_Modal.close();
                        }
                    });
                })
                .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                    Lemo_Modal.close();
                });

            Lemo_Modal.build();
        },

        /**
         * Inicializace objektu typu Miniform
         */
        miniformInit: function () {
            $('body')
                // Zrusime puvodni udalosti
                .off('click', '.miniform-item-add')
                .off('click', '.miniform-item-delete')
                .off('click', '.miniform-item-edit')
                .off('click', '.miniform-toggle-visibility')
                .off('click', '.miniform-item-toggle-visibility')

                // Zaregistrujeme nove udalosti
                .on('click', '.miniform-item-add', function (e) {
                    e.preventDefault();
                    DynaCore_Item.miniformItemAdd(this);
                    return false;
                })
                .on('click', '.miniform-item-delete', function (e) {
                    e.preventDefault();
                    DynaCore_Item.miniformItemDelete(this);
                    return false;
                })
                .on('click', '.miniform-item-edit', function (e) {
                    e.preventDefault();
                    DynaCore_Item.miniformItemEdit(this);
                    return false;
                })
                .on('click', '.miniform-toggle-visibility', function (e) {
                    e.preventDefault();
                    DynaCore_Item.miniformToggleVisibility(this);

                    return false;
                })
                .on('click', '.miniform-item-toggle-visibility', function (e) {
                    e.preventDefault();
                    DynaCore_Item.miniformItemToggleVisibility(this);

                    return false;
                });
        },

        /**
         * Pridani polozky objektu typu Miniform
         *
         * @param element
         */
        miniformItemAdd: function (element) {
            const parent = $(element).parents('.el-miniform');
            const heading = $(parent).data('heading-add');
            const partId = $(parent).data('part-id');
            const miniformId = $(parent).data('miniform-id');
            const miniformType = $(parent).data('miniform-type');
            const itemIndex = $('#miniformI' + partId + ' > tbody > tr[data-item-index]').length;
            let url = window.location.href;

            url = url.replace('/item/add', '/item/modal-miniform');
            url = url.replace('/item/duplicate', '/item/modal-miniform');
            url = url.replace('/item/edit', '/item/modal-miniform');
            url = url.replace('/my-account', '/my-account/modal-miniform');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&miId=' + miniformId + '&paId=' + partId + '&itIn=' + itemIndex + '&a=add';

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                success: function (data) {
                    $.each(data.messages, function (i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                    });

                    if (true === data.status) {
                        const formModified = DynaCore_Item.miniformItemSectionValuesLoad(data.html);

                        Lemo_Modal.setId('modal-container-miniform-item-add');
                        Lemo_Modal.setTitle(heading);
                        Lemo_Modal.setContent(formModified);
                        Lemo_Modal.addButton('add', '<i class="fas fa-fw fa-check"></i> ' + translate('Add'), 'btn btn-primary', function () {
                            const form = $('#miniform')[0]; // You need to use standart javascript object here
                            const formData = new FormData(form);

                            $.ajax({
                                type: 'post',
                                url: url,
                                data: formData,
                                dataType: "json",
                                contentType: false,
                                processData: false,
                                success: function (data) {
                                    $.each(data.messages, function (i, message) {
                                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                                    });

                                    if (true === data.status) {
                                        if (0 === itemIndex) {
                                            $('#miniformI' + partId + '-noItems').remove();
                                        }

                                        $('#miniformI' + partId + ' > tbody').append(data.html);

                                        // Do formulare polozky doplnime data z miniformulare
                                        DynaCore_Item.miniformItemSectionValuesPopulate('modal');

                                        $(document).trigger({
                                            type: 'modal.miniform.item.add.success',
                                            message: 'Miniform item add success trigger fired.',
                                            time: new Date()
                                        });

                                        DynaCore_Item.miniformReload(miniformId, partId);
                                        Lemo_Modal.close();
                                    } else {
                                        $('#dialogBody').html(data.html);
                                        $(document).trigger({
                                            type: 'modal.miniform.item.add.error',
                                            message: 'Miniform item add error trigger fired.',
                                            time: new Date()
                                        });
                                    }
                                }
                            });
                        });
                        Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                            Lemo_Modal.close();
                        });
                        Lemo_Modal.build(function () {

                            // Create iframe
                            Lemo_Modal.createUploadIframe(miniformType);

                            DynaCore_Item.fileInit();

                            // Trigger event
                            $(document).trigger({
                                type: 'modal.miniform.item.add.build',
                                message: 'Miniform item add trigger fired.',
                                time: new Date()
                            });
                        });
                    }
                },
                error: function (jqXHR) {
                    DynaCore_Item.alertXhrError(jqXHR);
                }
            });
        },

        /**
         * Upraveni polozky objektu typu Miniform
         *
         * @param element
         */
        miniformItemEdit: function (element) {
            const parent = $(element).parents('.el-miniform');
            const heading = $(parent).data('heading-edit');
            const elementTr = $(element).parents('tr');
            const itemIndex = $(elementTr).data('item-index');
            const miniformId = $(parent).data('miniform-id');
            const miniformType = $(parent).data('miniform-type');
            const partId = $(parent).data('part-id');

            let url = window.location.href;
            url = url.replace('/item/add', '/item/modal-miniform');
            url = url.replace('/item/duplicate', '/item/modal-miniform');
            url = url.replace('/item/edit', '/item/modal-miniform');
            url = url.replace('/my-account', '/my-account/modal-miniform');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&miId=' + miniformId + '&paId=' + partId + '&itIn=' + itemIndex + '&a=edit';

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                success: function (data) {
                    $.each(data.messages, function (i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                    });

                    if (true === data.status) {
                        const formModified = DynaCore_Item.miniformItemSectionValuesLoad(data.html);

                        Lemo_Modal.setId('modal-container-miniform-item-edit');
                        Lemo_Modal.setTitle(heading);
                        Lemo_Modal.setContent(formModified);
                        Lemo_Modal.addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function () {
                            const form = $('#miniform')[0]; // You need to use standart javascript object here
                            const formData = new FormData(form);

                            $.ajax({
                                type: 'post',
                                url: url,
                                data: formData,
                                dataType: "json",
                                contentType: false,
                                processData: false,
                                success: function (data) {
                                    $.each(data.messages, function (i, message) {
                                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                                    });

                                    if (true === data.status) {
                                        // Nahradime radek
                                        $(elementTr).replaceWith(data.html);

                                        // Do formulare polozky doplnime data z miniformulare
                                        DynaCore_Item.miniformItemSectionValuesPopulate('modal');

                                        $(document).trigger({
                                            type: 'modal.miniform.item.edit.success',
                                            message: 'Miniform item edit success trigger fired.',
                                            time: new Date()
                                        }, {'uuid': $(elementTr).data('item-uuid')});

                                        DynaCore_Item.miniformReload(miniformId, partId);
                                        Lemo_Modal.close();
                                    } else {
                                        $('#dialogBody').html(data.html);
                                        $(document).trigger({
                                            type: 'modal.miniform.item.edit.error',
                                            message: 'Miniform item edit error trigger fired.',
                                            time: new Date()
                                        });
                                    }
                                }
                            });
                        });
                        Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                            $(document).trigger({
                                type: 'modal.miniform.item.edit.cancel',
                                message: 'Miniform item cancel trigger fired.',
                                time: new Date()
                            }, {'uuid': $(elementTr).data('item-uuid')});
                            Lemo_Modal.close();
                        });
                        Lemo_Modal.build(function () {

                            // Create iframe
                            Lemo_Modal.createUploadIframe(miniformType);

                            DynaCore_Item.fileInit();

                            // Trigger event
                            $(document).trigger({
                                type: 'modal.miniform.item.edit.build',
                                message: 'Miniform item edit trigger fired.',
                                time: new Date()
                            });
                        });
                    }
                },
                error: function (jqXHR) {
                    DynaCore_Item.alertXhrError(jqXHR);
                }
            });
        },

        /**
         * Smazani polozky objektu typu Miniform
         *
         * @param element
         */
        miniformItemDelete: function (element) {
            const parent = $(element).parents('.el-miniform');
            const heading = $(parent).data('heading-delete');
            const elementTr = $(element).parents('tr');
            const itemIndex = $(elementTr).data('item-index');
            const miniformId = $(parent).data('miniform-id');
            const partId = $(parent).data('part-id');

            let url = window.location.href;
            url = url.replace('/item/add', '/item/miniform-item-delete');
            url = url.replace('/item/duplicate', '/item/miniform-item-delete');
            url = url.replace('/item/edit', '/item/miniform-item-delete');
            url = url.replace('/my-account', '/my-account/miniform-item-delete');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&miId=' + miniformId + '&paId=' + partId + '&itIn=' + itemIndex;

            Lemo_Modal.setId('modal-container-miniform-item-delete')
            Lemo_Modal.setTitle(heading);
            Lemo_Modal.setContent('<p class="text">' + translate('Do you really want to remove selected item?') + '</p>');
            Lemo_Modal.addButton('remove', '<i class="fas fa-fw fa-trash"></i> ' + translate('Remove'), 'btn btn-danger', function () {
                $.ajax({
                    type: 'get',
                    url: url,
                    dataType: "json",
                    complete: function() {
                        $(document).trigger({
                            type: "dynabase.force.deactivation",
                            message: "Miniform reload complete trigger fired.",
                            time: new Date()
                        });
                    },
                    success: function (data) {
                        $.each(data.messages, function (i, message) {
                            Lemo_Alert.build(message.type, message.title, message.text, message.id);
                        });

                        if (true === data.status) {
                            $('#miniformI' + partId + ' > tbody').html(data.html);

                            Lemo_Modal.close();
                        }
                    },
                    error: function (jqXHR) {
                        DynaCore_Item.alertXhrError(jqXHR);
                    }
                });
            });
            Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                Lemo_Modal.close();
            });
            Lemo_Modal.build();
        },

        /**
         * Zmeni viditelnost jende polozky
         *
         * @param element
         */
        miniformItemToggleVisibility: function (element) {
            const parent = $(element).parents('.el-miniform');
            const elementTr = $(element).parents('tr');
            const itemIndex = $(elementTr).data('item-index');
            const miniformId = $(parent).data('miniform-id');
            const partId = $(parent).data('part-id');

            let url = window.location.href;
            url = url.replace('/item/add', '/item/miniform-item--toggle-visibility');
            url = url.replace('/item/edit', '/item/miniform-item--toggle-visibility');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&miId=' + miniformId + '&paId=' + partId + '&itIn=' + itemIndex;

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                success: function (data) {
                    $.each(data.messages, function (i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                    });

                    console.log("miniform reload");

                    DynaCore_Item.miniformReload(miniformId, partId);
                },
                error: function (jqXHR) {
                    DynaCore_Item.alertXhrError(jqXHR);
                }
            });
        },

        /**
         * Nacte hodnoty do poli miniformulare u poli pochazejicich ze sekce
         *
         * @param {outerHTML} html
         * @returns {outerHTML}
         */
        miniformItemSectionValuesLoad: function (html) {
            let htmlModified = $(html)[0].outerHTML;

            // Nacteme vychozi hodnoty pro pole pouzita ze sekce
            $(html).find('[data-source="section"]').each(function (i, element) {
                const id = $(element).attr('id').replace(/modal-/, '');
                const value = $('#' + id).val();
                const isSelect = $(element).is('select');
                const elementOriginal = element.outerHTML;

                if (true === isSelect) {
                    $(element).children('[value="' + value + '"]').attr('selected', true).prop('selected', true);
                } else {
                    $(element).attr('value', value).val(value);
                }

                const elementModified = $(element)[0].outerHTML;

                htmlModified = htmlModified.replace(elementOriginal, elementModified);
            });

            return htmlModified;
        },

        /**
         * Doplni hodnoty do poli polozky z miniformulare u poli pochazejicich ze sekce
         */
        miniformItemSectionValuesPopulate: function (id) {
            if (typeof id === 'undefined' || !id.length) {
                id = 'modal';
            }

            // Doplnime hodnoty ze sekce z Miniformulare do Formulare sekce
            $('#' + id).find('[data-source="section"]').each(function (i, element) {
                let id = $(element).attr('id').replace(/modal-/, '');
                let value = $(element).val();
                let isSelect = $(element).is('select');

                if (true === isSelect) {
                    $('#' + id).children('[value="' + value + '"]').attr('selected', true).prop('selected', true);
                } else {
                    $('#' + id).val(value);
                }
            });
        },


        miniformToggleVisibility(element) {
            const parent = $(element).parents('.el-miniform');
            const miniformId = $(parent).data('miniform-id');
            const partId = $(parent).data('part-id');

            let url = window.location.href;
            url = url.replace('/item/add', '/item/modal-miniform');
            url = url.replace('/item/edit', '/item/modal-miniform');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&miId=' + miniformId + '&paId=' + partId + '&a=toggle-items-visibility';

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                success: function (data) {
                    $.each(data.messages, function (i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                    });

                    const toggleButtons = $(parent).find(".miniform-toggle-visibility");
                    if (toggleButtons.length) {
                        $.each(toggleButtons, function (i, button) {
                            if ($(button).hasClass('d-none')) {
                                $(button).removeClass('d-none');
                            } else {
                                $(button).addClass('d-none');
                            }
                        });
                    }

                    DynaCore_Item.miniformReload(miniformId, partId);
                },
                error: function (jqXHR) {
                    DynaCore_Item.alertXhrError(jqXHR);
                }
            });
        },

        /**
         * Reindexace polozek v tabulce objektu typu Miniform
         *
         * @param miniformIndex
         */
        miniformReindex: function (miniformIndex) {
            $('#miniformI' + miniformIndex).find('tbody > tr').not('#miniformI' + miniformIndex + '-noItems').each(function (indexRow, row) {
                $(row).attr('data-item-index', indexRow);
            });
        },

        /**
         * Upraveni polozky objektu typu Miniform
         *
         * @param miniformId
         * @param miniformIndex
         */
        miniformReload: function (miniformId, miniformIndex) {
            const elementTbody = $('#miniformI' + miniformIndex).find('tbody');

            let url = window.location.href;
            url = url.replace('/item/add', '/item/miniform-reload');
            url = url.replace('/item/duplicate', '/item/miniform-reload');
            url = url.replace('/item/edit', '/item/miniform-reload');
            url = url.replace('/my-account', '/my-account/miniform-reload');
            url += ((url.indexOf('?') === -1) ? '?' : '&');
            url = url + '_ch=' + $('#_ch').val() + '&miId=' + miniformId + '&miIn=' + miniformIndex;

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                complete: function () {
                    $(document).trigger({
                        type: "dynabase.force.deactivation",
                        message: "Miniform reload complete trigger fired.",
                        time: new Date()
                    });
                },
                success: function (data) {
                    $.each(data.messages, function (i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text, message.id);
                    });

                    // Nahradime miniform
                    if (true === data.status) {
                        elementTbody.replaceWith('<tbody>' + data.html + '</tbody>');
                    }
                }
            });
        },

        /**
         * Inicializace vlastnosti formulare
         */
        refreshInit: function () {

            const body = $('body');

            body
                .on('change', 'select.refresh, :radio.refresh, :checkbox.refresh', function () {
                    let isModal = false;
                    let part = null;
                    if ($('#modal-button').length > 0) {
                        isModal = true;
                        part = 'button';
                    }
                    if ($('#modal-grid').length > 0) {
                        isModal = true;
                        part = 'grid';
                    }
                    if ($('#modal-miniform').length > 0) {
                        isModal = true;
                        part = 'miniform';
                    }

                    DynaCore_Item.refreshAction(part, isModal);
                })
                .on('blur', "textarea.refresh, input.refresh:not(':checkbox, :radio')", function () {
                    let isModal = false;
                    let part = null;
                    if ($('#modal-button').length > 0) {
                        isModal = true;
                        part = 'button';
                    }
                    if ($('#modal-grid').length > 0) {
                        isModal = true;
                        part = 'grid';
                    }
                    if ($('#modal-miniform').length > 0) {
                        isModal = true;
                        part = 'miniform';
                    }

                    DynaCore_Item.refreshAction(part, isModal);
                });

            body
                .on('change', 'select', function () {
                    if ($(this).parents('.input-group').find('.input-group-btn').length > 0) {
                        let value = this.value;

                        if ('' === value) {
                            value = 0;
                        }

                        $(this).parents('.input-group').find('a.btn').each(function (i, element) {
                            let url = $(element).attr('href');
                            url = url.replace(/\/(\d+)\//, '/' + value + '/');

                            if (value > 0) {
                                $(element).attr('href', url).removeClass('disabled');
                            } else {
                                $(element).attr('href', url).addClass('disabled');
                            }
                        });
                    }
                });
        },

        /**
         * Znovu nastavi formulari vlastnosti
         */
        refreshAction: function (part, isModal) {

            // Urcime si formular pro data
            let form = $('form');
            let modalPart = $('#modal-' + part);
            if (true === isModal) {
                form = modalPart.find('form');
            }

            // Vytvorime si sseznam neaktivnich elementu
            const neaktivniElementy = [];
            form.find('.el-form').find(':input:disabled').each(function (i, element) {
                $(element).attr('disabled', false).prop('disabled', false);
                neaktivniElementy[i] = $(element).attr('id');
            });

            // Nacteme si data ze jednotlivych elementu
            const data = form.serialize();

            // Neaktivni elementy opet nastavime na neaktivni
            $(neaktivniElementy).each(function (i, element) {
                $('#' + element).attr('disabled', true).prop('disabled', true);
            });

            let url = window.location.href;

            url = url.replace('/item/add', '/item/refresh');
            url = url.replace('/item/duplicate', '/item/refresh');
            url = url.replace('/item/edit', '/item/refresh');
            url = url.replace('/my-account', '/my-account/refresh');

            url += '?_ch=' + $('#_ch').val();
            url += '&tar=section';
            url += '&tarId=' + $('#idSection').val();

            if (true === isModal) {
                url += '&par=' + part;
                url += '&parId=' + modalPart.data('part-id');
                url += '&minId=' + modalPart.data('miniform-id');

                if ('grid' === part || 'miniform' === part) {
                    url += '&iteInd=' + modalPart.data('item-index');
                }
            }

            $.ajax({
                type: 'post',
                url: url,
                data: data,
                dataType: "json",
                complete: function() {
                    $(document).trigger({
                        type: "dynabase.force.deactivation",
                        message: "Form refresh complete trigger fired.",
                        time: new Date()
                    });
                },
                success: function (response) {
                    if (true === response.status) {
                        // PROPERTIES
                        $.each(response.data.properties, function (propertyPart, propertyItems) {
                            $.each(propertyItems, function (id, properties) {
                                $.each(properties, function (property, value) {
                                    let element = $(form).find('[data-id="' + propertyPart + '-' + id + '"]');

                                    let isField = false;
                                    if (
                                        'formField' === propertyPart ||
                                        'gridFieldModal' === propertyPart ||
                                        'gridFieldSection' === propertyPart ||
                                        'miniformFieldModal' === propertyPart ||
                                        'miniformFieldSection' === propertyPart
                                    ) {
                                        isField = true;
                                    }

                                    if (true === isField) {

                                        // Osetreni Autocomplete pole
                                        let elementId = $(element).attr('id');
                                        let elementAutocomplete = $('#' + elementId + 'Autocomplete');
                                        if ($(element).is(':hidden') && elementAutocomplete.length > 0) {
                                            element = elementAutocomplete;
                                        }

                                        // Disabled
                                        if ('isDisabled' === property) {
                                            $(element).prop('disabled', value).attr('disabled', value);
                                        }

                                        // Hidden
                                        if ('isHidden' === property) {
                                            if (true === value) {
                                                $(element).parents('.form-group').addClass('d-none');
                                            } else {
                                                $(element).parents('.form-group').removeClass('d-none');
                                            }
                                        }

                                        // Readonly
                                        if ('isReadonly' === property) {
                                            $(element).prop('readonly', value).attr('readonly', value);
                                        }

                                        // Required
                                        if ('isRequired' === property) {
                                            const labelElement = $(element).parents('.form-group').find('.control-label,.col-form-label');
                                            let labelHtml = labelElement.html();

                                            if (null != labelHtml) {
                                                labelHtml = labelHtml.replace(' <em class="required">*</em>', '');
                                                labelHtml = labelHtml.replace(' <EM class=required>*</EM>', '');
                                            }
                                            labelElement.html(labelHtml);

                                            // Povinne
                                            if (true === value) {
                                                labelElement.html(labelHtml + ' <em class="required">*</em>');
                                            }
                                        }
                                    } else if ('isDisabled' === property && ('miniform' === propertyPart || 'grid' === propertyPart)) {
                                        $(element).find('button.btn')
                                            .not('[data-disabled="disabled"]')
                                            .prop('disabled', value)
                                            .attr('disabled', value);

                                        if (true === value) {
                                            $(element).find('a.btn')
                                                .not('[data-disabled="disabled"]')
                                                .addClass('disabled');
                                        } else {
                                            $(element).find('a.btn')
                                                .not('[data-disabled="disabled"]')
                                                .removeClass('disabled');
                                        }
                                    } else if ('isDisabled' === property && 'button' === propertyPart) {
                                        $(element)
                                            .not('[data-disabled="disabled"]')
                                            .prop('disabled', value)
                                            .attr('disabled', value);

                                        if (true === value) {
                                            $(element)
                                                .not('[data-disabled="disabled"]')
                                                .addClass('disabled');
                                        } else {
                                            $(element)
                                                .not('[data-disabled="disabled"]')
                                                .removeClass('disabled');
                                        }
                                    } else if ('isReadonly' === property && ('miniform' === propertyPart || 'grid' === propertyPart)) {
                                        if (true === value) {
                                            $(element).find('.btn').addClass('d-none');
                                        } else {
                                            $(element).find('.btn').removeClass('d-none');
                                        }
                                    } else {
                                        const card = $(element).closest('.el-' + propertyPart + '-card');

                                        // Hidden
                                        if ('isHidden' === property) {
                                            if (true === value) {
                                                $(element).addClass('d-none');
                                                if (card.length) {
                                                    card.addClass('d-none');
                                                }
                                            } else {
                                                $(element).removeClass('d-none');
                                                if (card.length) {
                                                    card.removeClass('d-none');
                                                }
                                            }
                                        }
                                    }
                                });
                            });
                        });

                        // VALUE OPTIONS
                        $.each(response.data.valueOptions, function (fieldName, options) {
                            const $element = $(form).find('#' + fieldName);

                            // Odebere existujici polozky
                            $element.find('option').remove();

                            // Pridame nove polozky
                            $.each(options, function (i, item) {
                                $element.append($('<option value="' + item.i + '">' + item.n + '</option>'));
                            });

                            // Zneaktivnime pole, pokud nema zadne hodnoty
                            if ($element.find('option').length <= 1 && '' === $element.find('option:first').val()) {
                                $element.attr('disabled', true).prop('disabled', true);
                            } else {
                                $element.attr('disabled', false).prop('disabled', false);
                            }
                        });
                    }

                }
            });
        },

        tooltipInit: function () {
            $('.btn[data-toggle="tooltip"]').tooltip({
                delay: 500
            })
        },

        alertXhrError: function (jqXHR) {
            if (403 === jqXHR.status) {
                Lemo_Alert.addDanger(translate('You are not authorized to access this page'), 'dangerXhr403');
            }
            if (404 === jqXHR.status) {
                Lemo_Alert.addDanger(translate('Page not found'), 'dangerXhr404');
            }
            if (500 === jqXHR.status) {
                Lemo_Alert.addDanger(translate('An unknown error occurred'), 'dangerXhr500');
            }
        }
    };

$(document).ready(function () {
    DynaCore_Item.init();
});
